import { makeStyles } from '@fluentui/react-components';
export var useCarouselControlStyles = makeStyles({
    carousel: {
        marginBottom: '12px',
    },
});
//# sourceMappingURL=CarouselControl.styles.js.map